import { useState } from 'react'
import { CloseEyeIcon, OpenEyeIcon } from '../../assets/svg'
// import { CloseEyeIcon } from '../../assets/svg'

const InputField = ({
    type,
    name,
    lable,
    placeholder,
    value,
    onChange,
    onBlur,
    error,
    touched,
    defaultValue,
    classtype,
    onWheel,
    disabled,
}: {
    type: 'text' | 'password' | 'email' | 'date' | 'number'
    name?: string
    lable?: string
    placeholder?: string
    value?: string
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
    error?: string | undefined
    touched?: boolean | undefined
    defaultValue?: string | number
    classtype?: boolean
    onWheel?: (e: React.WheelEvent<HTMLDivElement>) => void
    disabled?: boolean
}) => {
    const [showPassword, setShowPassword] = useState(false)
    const handleShowPassword = () => {
        setShowPassword(!showPassword)
    }
    return (
        <div className="form mb-3">
            {lable && (
                <>
                    <label>{lable}</label>
                </>
            )}
            <div className="position-relative">
                <input
                    className={`form-control mt-2 form-control-password ${classtype ? 'date-control' : ''}`}
                    type={
                        type === 'password'
                            ? showPassword
                                ? 'text'
                                : 'password'
                            : type
                    }
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    defaultValue={defaultValue}
                    autoComplete="off"
                    onWheel={onWheel}
                    disabled={disabled}
                />
                {type === 'password' && (
                    <span onClick={handleShowPassword} className="icon-view">
                        {showPassword ? (
                            <img src={CloseEyeIcon}></img>
                        ) : (
                            <img src={OpenEyeIcon}></img>
                        )}
                    </span>
                )}
            </div>
            {error && touched && <div style={{ color: 'red' }}>{error}</div>}
        </div>
    )
}
export default InputField
